import { DocumentNode, gql } from '@apollo/client'

export const CREATE_STAFF_LEVEL: DocumentNode = gql`
    mutation CreateStaffLevel($daycareId: Int!, $name: String!, $required: Boolean) {
        createStaffLevel(daycareId: $daycareId, name: $name, required: $required)
    }
`

export const UPDATE_STAFF_LEVEL: DocumentNode = gql`
    mutation UpdateStaffLevel($staffLevelId: Int!, $name: String, $required: Boolean, $daycareId: Int!) {
        updateStaffLevel(staffLevelId: $staffLevelId, name: $name, required: $required, daycareId: $daycareId)
    }
`

export const DELETE_STAFF_LEVEL: DocumentNode = gql`
    mutation DeleteStaffLevel($staffLevelId: Int!, $daycareId: Int!) {
        deleteStaffLevel(staffLevelId: $staffLevelId, daycareId: $daycareId)
    }
`

export const GET_STAFF_LEVELS: DocumentNode = gql`
    query GetStaffLevels($daycareId: Int!) {
        getStaffLevels(daycareId: $daycareId) {
            id
            name
            required
        }
    }
`

export const UPDATE_STAFF_LINK_LEVEL: DocumentNode = gql`
    mutation UpdateStaffLinkLevel($staffLinkId: Int!, $daycareId: Int!, $staffLevelId: Int) {
        updateStaffLinkLevel(daycareId: $daycareId, staffLinkId: $staffLinkId, staffLevelId: $staffLevelId)
    }
`
